document.addEventListener('DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.challenge_cook_tabs .challenge_cook_tab')).forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      removeActiveClassInPointTabContents();
      tab.classList.add('active');
      document.querySelector(tab.dataset.container).classList.add('active');
    });
  });
})

function removeActiveClassInPointTabContents() {
  Array.from(document.querySelectorAll('.challenge_cook_tabs .challenge_cook_tab')).forEach((_tab) =>{
    _tab.classList.remove('active')
  }
  );
  Array.from(document.querySelectorAll('.challenge_cook_main_content')).forEach((container) => {
    container.classList.remove('active')
  }
  );
}

function open_modal_tsukulog(id_modal) {
  const modal = document.querySelector(id_modal);
  const body = document.body;

  // モーダルを閉じる
  modal.querySelector('.modal-close').addEventListener('click', () => {
    modal.classList.remove('active');
    body.style.overflow = 'auto';
  });

  // モーダル表示
  modal.classList.add('active');
  body.style.overflow = 'hidden';
}

// エラーが発生した際のスクロール処理
function scrollToErrorElement() {
  const errorElement = document.querySelector('.error');
  if (errorElement) {
    const elementRect = errorElement.getBoundingClientRect();
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const scrollToY = scrollY + elementRect.top - 120;
    window.scroll({
      top: scrollToY,
      behavior: 'smooth',
    });
  }
}

function duplicateRecipeName() {
  const queryParams = window.location.search;
  let target = document.querySelector('[mycooklist_recipe_name]');
  let errorMsg = 'すでに登録されている料理名は使用できません。<br>別の名前で登録してください'
  if (queryParams.includes('?view=mycooklist-create')) {
    target = document.querySelector('[mycooklist_title]');
    errorMsg = 'このタイトルは登録済みです。<br>別のタイトルをお試しください。';
  }
  
  fontJun501(errorMsg);
  target.nextElementSibling.hidden = false;
  target.nextElementSibling.innerHTML = errorMsg;
  target.classList.add('error');

  scrollToErrorElement();
}

async function fetchChallengeCookEvaluations(challengeCookId, limit) {
  return await fetch(`/apps/proxy/api/customers/challengeCook/evaluations/${challengeCookId}?limit=${limit}`)
    .then(res => res.json())
    .then(({ average, count, reviews, reviewCount }) => {
      return {
        average,
        count,
        reviews,
        reviewCount
      }
    })
    .catch(error => console.error(error));
}

async function fetchChallengeCookReviews(challengeCookId, limit, cursorPk=null, cursorCreatedAt=null) {
  let url = `/apps/proxy/api/customers/challengeCook/reviews/${challengeCookId}?limit=${limit}`

  if (cursorPk && cursorCreatedAt) {
    url += `&cursorPk=${cursorPk}&cursorCreatedAt=${cursorCreatedAt}`
  }

  return await fetch(url)
    .then(res => res.json())
    .then(({ reviews }) => {
      return reviews
    })
    .catch(error => console.error(error));
}

function updateEvaluations(average, count, reviews, reviewCount) {
  updateReviewCount(count)
  updateRateStar(average)
  updateRateValue(average)
  createReviewItems(reviews)
  showOrRemoveShowMoreButton(reviewCount)
}

function updateReviewCount(count, threshold=99) {
  let tabText = ''
  if (count > threshold) {
    tabText = `みんなのレビュー(${threshold}+)`
  } else {
    tabText = `みんなのレビュー(${count})`
  }
  
  const tagElem = document.getElementById('challenge_cook_tab-count')
  tagElem.innerText = tabText
}

/**
  updateRateStar
  空の星画像と塗りつぶされた星画像をCSSで２枚重ねており、レビューの値に応じて塗りつぶされた星画像の表示割合を変更する。
**/
function updateRateStar(average) {
  const filledStarElems = document.querySelectorAll('.challenge_cook_evaluation-filled');
  const emptyStarElems = document.querySelectorAll('.challenge_cook_evaluation-empty');

  filledStarElems.forEach(star => star.style.width = '0px');

  const integerStar = Math.floor(average);
  const fractionStar = average - integerStar;
  
  const emptyStartWidth = getComputedStyle(emptyStarElems[0]).width.replace('px', '');

  filledStarElems.forEach((filledStarElem, index) => {
    if (index < integerStar) {
      filledStarElem.style.width = `${emptyStartWidth}px`;
    } else if (index === integerStar) {
      filledStarElem.style.width = `${emptyStartWidth * fractionStar}px`;
    }
  });
}

function updateRateValue(average) {
  const rateValueElem = document.getElementById('challenge_cook_evaluation_highly')
  rateValueElem.innerText = Number.parseFloat(average).toFixed(2)
}

function createReviewItems(reviews) {
  const noReviewText = document.querySelector('.no-review-text');
  
  if (!reviews || reviews.length === 0) {
    noReviewText.style.display = 'block';
    return;
  }
  
  noReviewText.style.display = 'none';
  
  reviews.forEach((review, index) => {
    const reviewItem = createReviewItem(review);
    document.querySelector('#comment-box').appendChild(reviewItem);

    if (index === reviews.length-1) {
      const showMoreReviewButton = document.getElementById('showMoreReviews')
      showMoreReviewButton.dataset.id = review.id
      showMoreReviewButton.dataset.createdAt = review.createdAt
    }
  });

  const reviewCommentElems = document.querySelectorAll('.mizkan__top__main__comment-item');

  let allText = '';
  reviewCommentElems.forEach(reviewCommentElem => {
    const commentName = reviewCommentElem.querySelector('.name').textContent;
    const commentContent = reviewCommentElem.querySelector('.comment-content').textContent;
    allText += ' ' + commentName + commentContent;
  });

  fontJun34(allText);

  document.querySelector('.comment-loading').classList.remove('is-loading');
}

function createReviewItem(review) {
  const reviewItem = document.createElement('div');
  reviewItem.classList.add('mizkan__top__main__comment-item');

  const authorIcon = document.createElement('img');
  // ドメインに基づいて異なるアイコンURLを設定
  let defaultIconUrl;
  if (window.location.hostname === '365.mizkan.co.jp') {
      defaultIconUrl = '//365.mizkan.co.jp/cdn/shop/files/user_icon_1.png';
  } else {
      defaultIconUrl = '//dev-365.myshopify.com/cdn/shop/files/user_icon_1.png';
  }
  authorIcon.classList.add('author-icon');
  const authorIconUrl = review.usericon || defaultIconUrl;
  authorIcon.src = authorIconUrl;
  authorIcon.alt = review.nickname + "のアイコン";
  reviewItem.appendChild(authorIcon);

  const textBox = document.createElement('div');
  textBox.classList.add('mizkan__top__main__comment__text-box');
  reviewItem.appendChild(textBox);

  const name = document.createElement('span');
  name.classList.add('name');
  name.textContent = review.nickname;
  textBox.appendChild(name);

  const commentContent = document.createElement('p');
  commentContent.classList.add('comment-content');
  commentContent.textContent = review.review;
  textBox.appendChild(commentContent);

  return reviewItem;
}

function showOrRemoveShowMoreButton(reviewCount) {
  const commentBoxElem = document.getElementById('comment-box')
  const showMoreButton = document.getElementById('showMoreReviews')
  if (commentBoxElem.childElementCount >= reviewCount) {
    showMoreButton.remove()
  } else {
    showMoreButton.disabled = false
  }
}

async function getMoreReviews(challengeCookId, cursorPk, cursorCreatedAt, reviewCount, limit) {
  const reviews = await fetchChallengeCookReviews(challengeCookId, limit, cursorPk, cursorCreatedAt)
  createReviewItems(reviews)
  showOrRemoveShowMoreButton(reviewCount)
}
